// Components==============
import { useState } from 'react';
import { FilterType } from 'typings';
import { getInitialFilterValues } from 'utilities/getInitialFilterValues';
import { useTranslate } from './useTranslate';
// =========================

export type FilterArguments =
  | 'buildingBlocks'
  | 'projects'
  | 'courses'
  | 'my-courses'
  | 'my-work';

export function useFilter(type: FilterArguments) {
  const translate = useTranslate();

  const initial = getInitialFilterValues(type, translate);

  const [filterValues, setFilterValues] = useState<FilterType[]>(initial);

  return { filterValues, setFilterValues, initial };
}
